import { createConsumer } from '@rails/actioncable';
import axios from '../api/axios';

export function collaborationCableUrl(base, token) {
  const url = new URL(base, window.location.origin);
  url.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
  url.pathname = '/api/v1/cable';
  url.search = '';
  url.hash = '';
  url.searchParams.set('cable_token', token);
  return url.toString();
}

export async function createAuthorizedConsumer(resource) {
  const { data } = await axios.post('/record_collaborations', resource);
  if (!data?.cable_token) throw new Error('Missing collaboration ticket');
  return createConsumer(collaborationCableUrl(axios.defaults.baseURL, data.cable_token));
}
